// VESTED BLOCKS
// ===================================================

var vested_blocks = {

    settings: {
        digital_issues: $('.vested-digital-issues'),
        hero: $('.block-vested-hero'),
        vested_modals: $('.component-vested-modal'),
    },

    init: function() {
        // Digital Issues Grid
        if (this.settings.digital_issues.length) {
            this.digitalIssuesGrid();
        }
        // Hero
        if (this.settings.hero.length) {
            this.vestedHero();
        }
        // VESTED Modal
        if (this.settings.vested_modals.length) {
            this.vestedModals();
        }
    },

    // Digital Issues Grid
    digitalIssuesGrid: function() {

        vested_blocks.settings.digital_issues.each(function() {

            // View More Controls
            var view_more = $(this).find('.js-view-more-vested-issues');
            var increment = view_more.data('view-more-increment');
            var articles = $(this).find('.article.hidden');
            
            // On clicking View More button
            view_more.on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    // Show the next X number based on set increment
                    articles.slice(0,increment).removeClass('hidden');
                    // Remove those from the selection
                    articles.splice(0,increment);
                    // Remove button if all are in view
                    if (articles.length <= 0) {
                        view_more.remove();
                    }
                }
            });

            // VESTED modal elements
            var vested_modal_triggers = $(this).find('[data-issuu-id]');
            var vested_modal = $(this).closest('section').find('.component-vested-modal');
            var vested_modal_iframe = vested_modal.find('#issuu-iframe');

            vested_modal_triggers.on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    updateVestedModal($(this).data('issuu-id'));
                }
            });

            // Dropdown menu
            var vested_dropdown = $(this).find('#issue-selection');

            vested_dropdown.on('change', function() {
                updateVestedModal($(this).find(':selected').val());
            });

            function updateVestedModal(issuu_id) {
                // Build the iframe src
                var issuu_src = '//e.issuu.com/embed.html?&hideIssuuLogo=true&hideShareButton=true&u=captrust&backgroundColor=%23222d36&d=' + issuu_id;
                // Switch to single page view on smaller screens
                if ($(document).width() < 1280) {
                    issuu_src += '&pageLayout=singlePage';
                }
                // Update the iframe src
                vested_modal_iframe.attr('src', issuu_src);
                // Open the modal
                vested_modal.addClass('active')
                $('body').addClass('no-scroll');
            }
    
        });
        
    },

    // Hero
    vestedHero: function() {

        vested_blocks.settings.hero.each(function() {

            var options_paused = {
                allowTouchMove: false,
                autoplay: false,
                direction: 'vertical',
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 35,
                speed: 17000,
            }

            var options_playing = {
                allowTouchMove: false,
                autoplay: {
                    delay: 0,
                },
                direction: 'vertical',
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 35,
                speed: 17000,
            }

            var carousel = $(this).find('.vested-carousel');
            var controls = $(this).find('.carousel-controls');
        
            // Initialize Carousel
            var swiper = new Swiper(carousel[0], options_playing);
            
            controls.on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    if (controls.hasClass('playing')) {
                        // Pause Carousel
                        controls.removeClass('playing');
                        controls.addClass('paused');
                        swiper.destroy();
                        swiper = new Swiper(carousel[0], options_paused);
                    } else {
                        // Play Carousel
                        controls.removeClass('paused');
                        controls.addClass('playing');
                        swiper.destroy();
                        swiper = new Swiper(carousel[0], options_playing);
                    }
                }
            });

        });

    },

    // VESTED Modal
    vestedModals: function() {

        vested_blocks.settings.vested_modals.each(function() {

            var modal = $(this);
            var close = modal.find('.js-close-vested-modal');

            close.on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    modal.removeClass('active');
                    $('body').removeClass('no-scroll');
                }
            });

        });

    }

};
vested_blocks.init();